// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","list":"Navbar_list__KoTsZ","item":"Navbar_item__Ccd2B"};